import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { ApiParameter, patch, post } from "@insite/client-framework/Services/ApiService";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";

export interface AddCartWishListApiParameter extends ApiParameter {
    wishListLines: ProductInfo[];
    name?: string;
    senderName?: string;
    senderEmail?: string;
    recipientEmail?: string;
    description?: string;
    isSharedCart?: string;
}
const wishListUrl = "/api/v1/shareCart";

export async function addSharedWishList(parameter: AddCartWishListApiParameter) {
   
    try{
        const wishListModel = await patch<WishListModel>(`${wishListUrl}/sendCopy`, parameter);
        return wishListModel;
    }
    catch(error)
    {
        throw error;
    }
    
}